<template>
  <div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="search">
      <el-form-item label="流程名称"><el-input v-model="dataForm.definitionName" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="单据类型">
        <el-select v-model="dataForm.bizType" clearable size="small" style="width:150px">
          <el-option v-for="o in bizTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="启用">
        <el-select v-model="dataForm.enabled" clearable size="small" style="width:90px">
          <el-option label="是" value="1" /><el-option label="否" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('workflow:definition:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('workflow:definition:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageRows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" :index="indexMethod" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="definitionName" label="流程名称" min-width="140" header-align="center" align="left">
        <template slot-scope="s">
          <a v-if="isAuth('workflow:definition:info')" class="code-link" @click="open(s.row.definitionId, true)">{{ s.row.definitionName }}</a>
          <span v-else>{{ s.row.definitionName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bizType" label="单据类型" width="130" header-align="center" align="left">
        <template slot-scope="s">{{ bizTypeLabel(s.row.bizType) }}</template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级" width="80" header-align="center" align="left" />
      <el-table-column prop="remark" label="备注" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="enabled" label="启用" width="70" header-align="center" align="center">
        <template slot-scope="s">
          <el-tag :type="s.row.enabled === '1' ? 'success' : 'info'" size="mini">{{ s.row.enabled === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="v => { pageIndex = v }"
      @size-change="v => { pageSize = v; pageIndex = 1 }"
      :current-page="pageIndex" :page-size="pageSize" :total="filtered.length"
      layout="total, sizes, prev, pager, next" style="margin-top:12px" />
    <definition-dialog v-if="visible" ref="dlg" :biz-type-options="bizTypeOptions" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './workflowAuth'
import DefinitionDialog from './DefinitionDialog.vue'

export default {
  name: 'WorkflowDefinition',
  mixins: [auth],
  components: { DefinitionDialog },
  data() {
    return {
      dataForm: { definitionName: '', bizType: '', enabled: '' },
      bizTypeOptions: [],
      all: [],
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      visible: false
    }
  },
  computed: {
    filtered() {
      const q = this.dataForm
      return this.all.filter(row => {
        if (q.definitionName && String(row.definitionName || '').indexOf(q.definitionName) < 0) return false
        if (q.bizType && row.bizType !== q.bizType) return false
        if (q.enabled && String(row.enabled) !== q.enabled) return false
        return true
      })
    },
    pageRows() {
      const start = (this.pageIndex - 1) * this.pageSize
      return this.filtered.slice(start, start + this.pageSize)
    }
  },
  created() { this.loadBizTypes(); this.load() },
  activated() { this.loadBizTypes(); this.load() },
  methods: {
    loadBizTypes() {
      request.get('/workflow/definition/bizTypes').then(res => {
        this.bizTypeOptions = (res.data || []).map(item => ({ value: item.docType, label: item.docName }))
      }).catch(() => {})
    },
    bizTypeLabel(value) {
      const hit = this.bizTypeOptions.find(o => o.value === value)
      return hit ? hit.label : value
    },
    indexMethod(index) { return (this.pageIndex - 1) * this.pageSize + index + 1 },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.post('/workflow/definition/list', {}).then(res => { this.all = res.data || [] }).catch(() => { this.all = [] }).finally(() => { this.loading = false })
    },
    open(id, readonly) {
      this.visible = true
      this.$nextTick(() => this.$refs.dlg.init(id, readonly))
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
</style>
